// import SoundManager from './SoundManager.js';

import SauvegardeManager from "../prefabs/SauvegardeManager";

export default class Boot extends Phaser.Scene {

    constructor() {
        super({
            key: "Boot"
        })
    }
    init(data){
        console.log('Start :',this.scene.key, data);
        this.sauvegardeManager = new SauvegardeManager();

        var startScene = "Menu"
        var value = this.getUrlParam('scene', 'Empty')
        if(value!= undefined && value!=null && value!="" && value!='Empty'){
            startScene = value
        }

        var login = this.getUrlParam('login', 'Empty')
        if(login == undefined || login==null || login=="" || login=='Empty'){
            login = ""
        }else{
            this.sauvegardeManager.setLogin(login);

            this.sauvegardeManager.doPlayerExistsOnDatabase((exists) => {
                if(!exists){
                    this.sauvegardeManager.createOnDatabase();
                }
            });
        }

        var isMobile = /Mobi|Android/i.test(navigator.userAgent) || Phaser.Input.Touch.enabled;

        this.game.data = {
            sceneStopped : '',
            sceneRunning : '',
            login : login,
            'Preloader' : {
                next : startScene,
                sound: ''
            },
            isMobile: isMobile,
        }

        console.log("Game Data :", this.game.data);
    }

    preload() {

        // Preloader
        // Charge les fichiers pour le preloader

        // this.load.on('complete', function () {
            this.scene.start("Preloader");
        // }, this);

    }

    getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    };
    
    getUrlParam(parameter, defaultvalue) {
        var urlparameter = defaultvalue;
        if (window.location.href.indexOf(parameter) > -1) {
            urlparameter = this.getUrlVars()[parameter];
        }
        return urlparameter;
    };
}